import { definePreset } from '@primeng/themes';
import { TooltipStyles } from './ErmaComponents/TooltipStyles';
import { PrimitiveColors } from './ErmaColors/PrimitiveColors';
import { SemanticColors } from './ErmaColors/SemanticColors';
import { AutocompleteStyles } from './ErmaComponents/AutocompleteStyles';
import { ButtonStyles } from './ErmaComponents/ButtonStyles';
import { CheckboxStyles } from './ErmaComponents/CheckboxStyles';
import { ConfirmDialogStyles } from './ErmaComponents/ConfirmDialogStyles';
import { DatatableStyles } from './ErmaComponents/DatatableStyles';
import { DatepickerStyles } from './ErmaComponents/DatepickerStyles';
import { DialogStyles } from './ErmaComponents/DialogStyles';
import { FieldsetStyles } from './ErmaComponents/FieldsetStyles';
import { FileuploadStyles } from './ErmaComponents/FileuploadStyles';
import { InputgroupStyles } from './ErmaComponents/InputgroupStyles';
import { InputtextStyles } from './ErmaComponents/InputtextStyles';
import { MessageStyles } from './ErmaComponents/MessageStyles';
import { PaginatorStyles } from './ErmaComponents/PaginatorStyles';
import { ProgressSpinnerStyles } from './ErmaComponents/ProgressSpinnerStyles';
import { SelectStyles } from './ErmaComponents/SelectStyles';
import { TabsStyles } from './ErmaComponents/TabsStyles';
import { ToastStyles } from './ErmaComponents/ToastStyles';
import { ToolbarStyles } from './ErmaComponents/ToolbarStyles';
import { RadioButtonStyles } from './ErmaComponents/RadioButtonStyles';
import { TextareaStyles } from './ErmaComponents/TextareaStyles';
import { CardStyles } from './ErmaComponents/CardStyles';
import { SliderStyles } from './ErmaComponents/SliderStyles';
import { PopoverStyles } from './ErmaComponents/PopoverStyles';

/**
 * Téma pro Ermu
 */
export const ErmaPreset = definePreset({
  primitive: {
    borderRadius: {
      none: '0',
      xs: '1px',
      sm: '3px',
      md: '6px',
      lg: '8px',
      xl: '12px'
    },
    ...PrimitiveColors
  },
  semantic: {
    ...SemanticColors,
    icon: {
      size: '1rem'
    },
    disabled: {
      opacity: '.5'
    },
    maskBackground: '#0006',
    maskColor: 'var(--erma-secondary-900)'
  },
  components: {
    button: ButtonStyles,
    toolbar: ToolbarStyles,
    fieldset: FieldsetStyles,
    inputtext: InputtextStyles,
    inputgroup: InputgroupStyles,
    select: SelectStyles,
    tooltip: TooltipStyles,
    datatable: DatatableStyles,
    paginator: PaginatorStyles,
    tabs: TabsStyles,
    dialog: DialogStyles,
    confirmdialog: ConfirmDialogStyles,
    message: MessageStyles,
    toast: ToastStyles,
    datepicker: DatepickerStyles,
    progressspinner: ProgressSpinnerStyles,
    autocomplete: AutocompleteStyles,
    checkbox: CheckboxStyles,
    fileupload: FileuploadStyles,
    radiobutton: RadioButtonStyles,
    textarea: TextareaStyles,
    card: CardStyles,
    slider: SliderStyles,
    popover: PopoverStyles
  },
  css: ({ dt }) => ``
});
